<div style="padding: 24px">
  <h5 mat-dialog-title class="text-center">Nuevo generador / New Insured</h5>
  <div mat-dialog-content>
    <!--begin::Form-->
    <form class="form" [formGroup]="newGeneratorForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
      <div class="form-group">
        <br-alert *ngIf="showAlert"></br-alert>
        <p><strong>Fecha de creación / Date: </strong>{{ date | date : "MMMM d, y" }}</p>
        <mat-form-field class="w-100">
          <mat-label>Razón social / Insured Name</mat-label>
          <input matInput type="text" placeholder="ej. Razón Social S.A." formControlName="businessName" style="text-transform: capitalize" autocomplete="off" />
          <mat-error *ngIf="isControlHasError('businessName', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-select placeholder="Tipo documento / ID type" formControlName="documentType">
            <mat-option *ngFor="let docType of docTypes" [value]="docType.id">
              {{ docType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isControlHasError('documentType', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>N° documento (sin puntos) / ID number (Without Points)</mat-label>
          <input matInput type="number" placeholder="ej. 123456789" formControlName="nit" autocomplete="off" />
          <mat-error *ngIf="isControlHasError('nit', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Correo electrónico / Email</mat-label>
          <input matInput type="email" placeholder="ej. email@yopmail.com" formControlName="email" autocomplete="off" style="text-transform: lowercase" />
          <mat-error *ngIf="isControlHasError('email', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'email')">
            <strong>Correo electrónico invalido / Invalid Email</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Teléfono / Celular</mat-label>
          <input matInput type="text" [textMask]="{ mask: mask }" placeholder="ej. 300 000 0000" formControlName="phone" autocomplete="off" />
          <mat-error *ngIf="isControlHasError('phone', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Contacto (Nombres y apellidos) / Contact (Name and Last Name)</mat-label>
          <input matInput type="text" placeholder="ej. Juan Perez " style="text-transform: capitalize" formControlName="contact" autocomplete="off" />
          <mat-error *ngIf="isControlHasError('contact', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <input type="text" placeholder="País / Country" style="text-transform: capitalize" matInput formControlName="country" [matAutocomplete]="countryauto" />
          <mat-autocomplete #countryauto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="getCities($event.option.value.id)">
            <mat-option *ngFor="let option of filteredCountries | async" [value]="option">
              {{ option.name | titlecase }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="isControlHasError('country', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
          <input type="text" placeholder="Ciudad" matInput style="text-transform: capitalize" formControlName="city" [matAutocomplete]="cityauto" />
          <mat-autocomplete #cityauto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredCities | async" [value]="option">
              {{ option.name | titlecase }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="isControlHasError('city', 'required')">
            <strong>Campo requerido / Required Field</strong>
          </mat-error>
        </mat-form-field>
        <!-- <mat-form-field class="w-100">
          <mat-select placeholder="Tipo" formControlName="type">
            <mat-option *ngFor="let type of types" [value]="type.id">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isControlHasError('type', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
        </mat-form-field> -->
      </div>
    </form>
    <!--end::Form-->
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
    <button mat-button cdkFocusInitial (click)="submit(newGeneratorForm)">Crear / Save</button>
  </div>
</div>
